// import FormField from '@/components/common/FormField'
import { Button } from '@/components/ui/button'
import { Spinner } from '@/components/ui/spinner'
import { errorTypes } from '@/utility/validation'
import { useFormContext } from 'react-hook-form'
import type { OnboardTabProps } from './onboard.types'
// import SearchSelect from '@/components/common/SearchSelect'
import { ApplicationService } from '@/services/Applications/ApplicationService'
import { useEffect, useState } from 'react'
import { ThrowError } from '@/api/callApi'
import MultiSelectSearch from '@/components/common/MultiSelectSearch'

const OnboardClient: React.FC<OnboardTabProps> = ({ empId, handleClientSubmit }) => {
    const methods = useFormContext()
    const [isLoading, setIsLoading] = useState(false)
    const { register, watch, setValue, formState: { errors } } = methods
    const [applications, setApplications] = useState<{ value: string; label: string }[]>([])
    console.log(watch("clientIds"))

    const getApplications = async () => {
        setIsLoading(true)
        try {
            const response = await ApplicationService.getAllApplications()
            if (response?.status) {
                setApplications((response?.data?.clients || []).map((client) => ({
                    value: client.id,
                    label: client.name,
                })))
            }
        } catch (error) {
            ThrowError(error)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        getApplications()
        register("clientIds", { ...errorTypes.required("Client") })
    }, [register])

    return (
        <>
            <div className='space-y-4'>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <MultiSelectSearch
                        label="Applications"
                        required
                        placeholder="Select Applications"
                        options={applications}
                        value={watch("clientIds")}
                        onChange={(val) => setValue("clientIds", val, { shouldValidate: true })}
                        error={errors.clientIds?.message as string}
                    />
                    {/* /> */}

                </div>
                <div className="flex items-center justify-end mt-40">
                    <Button
                        type="button"
                        onClick={handleClientSubmit}
                        disabled={isLoading}
                    >
                        {isLoading ? <Spinner /> : (empId ? 'Update Employee' : 'Create Employee')}
                    </Button>
                </div>
            </div>
        </>
    )
}

export default OnboardClient
